import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import ReceitasEducacaoLogged from '../../../../components/auth/educacao/receitas'

function ReceitasEducacaoLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Receitas da Secretaria Municipal de Educação" />
                <HeaderLogged />
                <Container>
                   <ReceitasEducacaoLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ReceitasEducacaoLoggedScreen;